export default __webpack_public_path__ + "static/media/hantong.63b24722.jpeg";